import "../css/Message.css"
const Message = () => {
    return <div id="game-message"></div>
}
export default Message